import { useRef } from 'react';
import { Modal } from 'react-bootstrap';
import Draggable from 'react-draggable';
import { FormattedMessage } from 'react-intl';
import { IDefaultModalProps } from '../../models/forms/IModal';
import { CloseModalIcon } from '../svgs/svgs';

const DefaultModalDraggable = (props: IDefaultModalProps) => {
  const {
    size,
    headerText,
    cancelBtnText,
    saveUpdateBtnText,
    isLoading,
    children,
    className,
    onModalClosed,
  } = props;
  const modalRef = useRef(null);

  return (
    <Modal
      className={className}
      size={size}
      show={true}
      centered
      onHide={() => {}}
      dialogAs={() => (
        <Draggable
          handle=".modal-header"
          // nodeRef={modalRef}
          // ref={modalRef}
        >
          <div
            // ref={modalRef}
            className={`modal-dialog ${size ? `modal-${size}` : ''}`}
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <Modal.Header>
                  <Modal.Title>
                    <FormattedMessage id={headerText} />
                    <button
                      onClick={onModalClosed}
                      disabled={isLoading}
                      className="Crossicons"
                    >
                      <CloseModalIcon />
                    </button>
                  </Modal.Title>
                </Modal.Header>

                <div>{children}</div>
              </div>
            </div>
          </div>
        </Draggable>
      )}
    ></Modal>
  );
};

export default DefaultModalDraggable;
